import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

export interface MenuItem {
  id: string;
  // Display
  icon: string;
  title: string;
  desc: string;
  clrCode: string;
  // Menu hierarchy
  parentId: string | null;
  sort_ord: number;
  // Access / visibility
  locked: boolean;
  passcode: boolean;
  hidden: boolean;
  is_active: boolean;
  // Permission
  sa_only: boolean;
  for_module: boolean;
  // Navigation
  optClick: string;
  route: string;
  component: string;
}

@Component({
  selector: 'app-menu-items-settings',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './menu-items-settings.component.html',
  styleUrls: ['./menu-items-settings.component.css']
})
export class MenuItemsSettingsComponent {

  // ==========================================================
  // MENU DATA
  // ==========================================================
  menuItems: MenuItem[] = [
    // {
    //   id: '0',
    //   icon: 'bi-buildings',
    //   title: 'Organizations',
    //   desc: 'Add new organization details',
    //   parentId: null,
    //   sort_ord: 1,
    //   locked: false,
    //   passcode: false,
    //   hidden: false,
    //   is_active: true,
    //   sa_only: true,
    //   for_module: false,
    //   optClick: 'org',
    //   route: '/organizations',
    //   component: 'OrgListComponent',
    //   clrCode: '#38D5BE'
    // },
    // {
    //   id: '1',
    //   icon: 'bi-people',
    //   title: 'Users',
    //   desc: 'Manage application users',
    //   parentId: null,
    //   sort_ord: 2,
    //   locked: false,
    //   passcode: false,
    //   hidden: false,
    //   is_active: true,
    //   sa_only: true,
    //   for_module: false,
    //   optClick: 'users',
    //   route: '/users',
    //   component: 'UserListComponent',
    //   clrCode: '#6C63FF'
    // },
    // {
    //   id: '2',
    //   icon: 'bi-person-badge',
    //   title: 'Students',
    //   desc: 'Student management',
    //   parentId: null,
    //   sort_ord: 3,
    //   locked: false,
    //   passcode: false,
    //   hidden: false,
    //   is_active: true,
    //   sa_only: false,
    //   for_module: false,
    //   optClick: 'students',
    //   route: '/students',
    //   component: 'StudentListComponent',
    //   clrCode: '#FF9F43'
    // },
    // {
    //   id: '3',
    //   icon: 'bi-person-plus',
    //   title: 'Admission',
    //   desc: 'Manage student admissions',
    //   parentId: '2',
    //   sort_ord: 1,
    //   locked: false,
    //   passcode: false,
    //   hidden: false,
    //   is_active: true,
    //   sa_only: false,
    //   for_module: false,
    //   optClick: 'admission',
    //   route: '/students/admission',
    //   component: 'AdmissionComponent',
    //   clrCode: '#20C997'
    // },
    // {
    //   id: '4',
    //   icon: 'bi-person-lines-fill',
    //   title: 'Student List',
    //   desc: 'View and manage students',
    //   parentId: '2',
    //   sort_ord: 2,
    //   locked: false,
    //   passcode: false,
    //   hidden: false,
    //   is_active: true,
    //   sa_only: false,
    //   for_module: false,
    //   optClick: 'student-list',
    //   route: '/students/list',
    //   component: 'StudentListComponent',
    //   clrCode: '#20C997'
    // },
    // {
    //   id: '5',
    //   icon: 'bi-cash-stack',
    //   title: 'Fees',
    //   desc: 'Student fee management',
    //   parentId: null,
    //   sort_ord: 4,
    //   locked: false,
    //   passcode: false,
    //   hidden: false,
    //   is_active: true,
    //   sa_only: false,
    //   for_module: false,
    //   optClick: 'fees',
    //   route: '/fees',
    //   component: 'FeeComponent',
    //   clrCode: '#0D6EFD'
    // },
    // {
    //   id: '6',
    //   icon: 'bi-receipt',
    //   title: 'Fee Collection',
    //   desc: 'Collect student fees',
    //   parentId: '5',
    //   sort_ord: 1,
    //   locked: false,
    //   passcode: false,
    //   hidden: false,
    //   is_active: true,
    //   sa_only: false,
    //   for_module: false,
    //   optClick: 'fee-collection',
    //   route: '/fees/collection',
    //   component: 'FeeCollectionComponent',
    //   clrCode: '#0D6EFD'
    // },
    // {
    //   id: '7',
    //   icon: 'bi-clock-history',
    //   title: 'Pending Fees',
    //   desc: 'View pending fee records',
    //   parentId: '5',
    //   sort_ord: 2,
    //   locked: false,
    //   passcode: false,
    //   hidden: false,
    //   is_active: true,
    //   sa_only: false,
    //   for_module: false,
    //   optClick: 'pending-fees',
    //   route: '/fees/pending',
    //   component: 'PendingFeeComponent',
    //   clrCode: '#0D6EFD'
    // }
  ];


  // ==========================================================
  // FORM
  // ==========================================================
  formData: MenuItem = this.getEmptyForm();


  // ==========================================================
  // MODAL STATES
  // ==========================================================
  showFormModal = false;
  showViewModal = false;
  showDeleteModal = false;
  showJsonModal = false;

  isEditMode = false;
  selectedMenu: MenuItem | null = null;

  // ==========================================================
  // FILTER
  // ==========================================================
  searchText = '';
  filterType = 'all';
  filterStatus = 'all';
  currentPage = 1;
  pageSize = 10;

  // ==========================================================
  // DRAG
  // ==========================================================
  draggedItem: MenuItem | null = null;

  // ==========================================================
  // EMPTY FORM
  // ==========================================================
  getEmptyForm(): MenuItem {
    return {
      id: '',
      icon: 'bi-grid',
      title: '',
      desc: '',
      parentId: null,
      sort_ord: 1,
      locked: false,
      passcode: false,
      hidden: false,
      is_active: true,
      sa_only: false,
      for_module: false,
      optClick: '',
      route: '',
      component: '',
      clrCode: '#38D5BE'
    };
  }

  // ==========================================================
  // ROOT MENUS
  // ==========================================================
  get rootMenus(): MenuItem[] {
    return this.menuItems
      .filter(item => item.parentId === null)
      .sort((a, b) => a.sort_ord - b.sort_ord);
  }

  // ==========================================================
  // CHILD MENUS
  // ==========================================================
  getChildren(parentId: string): MenuItem[] {
    return this.menuItems
      .filter(item => item.parentId === parentId)
      .sort((a, b) => a.sort_ord - b.sort_ord);
  }


  // ==========================================================
  // FILTERED DATA
  // ==========================================================
  get filteredMenus(): MenuItem[] {
    const search = this.searchText
      .trim()
      .toLowerCase();

    return this.menuItems
      .filter(item => {
        const searchMatch =
          !search ||
          item.title.toLowerCase().includes(search) ||
          item.desc.toLowerCase().includes(search) ||
          item.optClick.toLowerCase().includes(search) ||
          item.route.toLowerCase().includes(search) ||
          item.component.toLowerCase().includes(search);

        let typeMatch = true;

        if (this.filterType === 'parent') {
          typeMatch = item.parentId === null;
        }

        if (this.filterType === 'child') {
          typeMatch = item.parentId !== null;
        }

        let statusMatch = true;

        if (this.filterStatus === 'active') {
          statusMatch = item.is_active;
        }

        if (this.filterStatus === 'inactive') {
          statusMatch = !item.is_active;
        }

        if (this.filterStatus === 'hidden') {
          statusMatch = item.hidden;
        }

        return searchMatch && typeMatch && statusMatch;
      })
      .sort((a, b) => {
        if (a.parentId === b.parentId) {
          return a.sort_ord - b.sort_ord;
        }

        return (a.parentId || '').localeCompare(
          b.parentId || ''
        );
      });
  }

  // ==========================================================
  // PAGINATION
  // ==========================================================
  get paginatedMenus(): MenuItem[] {
    const start = (this.currentPage - 1) * this.pageSize;

    return this.filteredMenus.slice(
      start,
      start + this.pageSize
    );
  }

  get totalPages(): number {
    return Math.ceil(
      this.filteredMenus.length / this.pageSize
    );
  }

  get pages(): number[] {
    return Array.from(
      { length: this.totalPages },
      (_, i) => i + 1
    );
  }


  get startRecord(): number {
    if (!this.filteredMenus.length) {
      return 0;
    }

    return ((this.currentPage - 1) * this.pageSize) + 1;
  }

  get endRecord(): number {
    return Math.min(
      this.currentPage * this.pageSize,
      this.filteredMenus.length
    );
  }


  // ==========================================================
  // ADD
  // ==========================================================
  openAddModal(parentId: string | null = null): void {
    this.isEditMode = false;
    this.formData = this.getEmptyForm();
    this.formData.parentId = parentId;
    this.formData.sort_ord = this.getNextSortOrder(parentId);
    this.showFormModal = true;
  }


  // ==========================================================
  // EDIT
  // ==========================================================
  openEditModal(item: MenuItem): void {
    this.isEditMode = true;
    this.formData = {
      ...item
    };
    this.showFormModal = true;
  }

  // ==========================================================
  // VIEW
  // ==========================================================
  openViewModal(item: MenuItem): void {
    this.selectedMenu = {
      ...item
    };
    this.showViewModal = true;
  }

  // ==========================================================
  // SAVE
  // ==========================================================
  saveMenu(): void {
    if (!this.formData.title.trim()) {
      return;
    }

    if (this.isEditMode) {
      const index = this.menuItems.findIndex(
        item => item.id === this.formData.id
      );

      if (index !== -1) {
        this.menuItems[index] = {
          ...this.formData,
          title: this.formData.title.trim(),
          sort_ord: Number(this.formData.sort_ord)
        };
      }
    } else {
      const newItem: MenuItem = {
        ...this.formData,
        id: this.generateId(),
        title: this.formData.title.trim(),
        sort_ord: Number(this.formData.sort_ord)
      };
      this.menuItems.push(newItem);
    }

    this.normalizeSortOrders();
    this.closeFormModal();
  }


  // ==========================================================
  // DELETE
  // ==========================================================
  openDeleteModal(item: MenuItem): void {
    this.selectedMenu = {
      ...item
    };
    this.showDeleteModal = true;
  }

  deleteMenu(): void {
    if (!this.selectedMenu) {
      return;
    }

    const id = this.selectedMenu.id;

    // Remove selected item
    this.menuItems = this.menuItems.filter(
      item => item.id !== id
    );

    // If parent is deleted, move children to root
    this.menuItems = this.menuItems.map(item => {
      if (item.parentId === id) {
        return {
          ...item,
          parentId: null
        };
      }

      return item;
    });

    this.normalizeSortOrders();
    this.showDeleteModal = false;
    this.selectedMenu = null;
  }


  // ==========================================================
  // TOGGLE ACTIVE
  // ==========================================================
  toggleActive(item: MenuItem): void {
    item.is_active = !item.is_active;
  }


  // ==========================================================
  // TOGGLE HIDDEN
  // ==========================================================
  toggleHidden(item: MenuItem): void {
    item.hidden = !item.hidden;
  }


  // ==========================================================
  // TOGGLE LOCKED
  // ==========================================================
  toggleLocked(item: MenuItem): void {
    item.locked = !item.locked;
  }


  // ==========================================================
  // GET PARENT NAME
  // ==========================================================
  getParentName(parentId: string | null): string {
    if (!parentId) {
      return 'Main Menu';
    }

    const parent = this.menuItems.find(
      item => item.id === parentId
    );

    return parent?.title || 'Main Menu';
  }


  // ==========================================================
  // SORT ORDER
  // ==========================================================
  getNextSortOrder(parentId: string | null): number {
    const siblings = this.menuItems.filter(
      item => item.parentId === parentId
    );

    if (!siblings.length) {
      return 1;
    }

    return Math.max(
      ...siblings.map(item => item.sort_ord)
    ) + 1;
  }

  // ==========================================================
  // NORMALIZE SORT ORDERS
  // ==========================================================
  normalizeSortOrders(): void {
    const parentIds = [
      null,
      ...this.menuItems
        .map(item => item.parentId)
        .filter(
          (id, index, arr) =>
            id !== null &&
            arr.indexOf(id) === index
        )
    ];

    parentIds.forEach(parentId => {
      const siblings = this.menuItems
        .filter(item => item.parentId === parentId)
        .sort((a, b) => a.sort_ord - b.sort_ord);

      siblings.forEach((item, index) => {
        item.sort_ord = index + 1;
      });
    });
  }


  // ==========================================================
  // DRAG START
  // ==========================================================
  onDragStart(item: MenuItem): void {
    this.draggedItem = item;
  }


  // ==========================================================
  // DRAG OVER
  // ==========================================================
  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }


  // ==========================================================
  // DROP
  // ==========================================================
  onDrop(target: MenuItem): void {
    if (!this.draggedItem) {
      return;
    }

    if (this.draggedItem.id === target.id) {
      return;
    }

    // Only reorder items inside the same parent
    if (
      this.draggedItem.parentId !==
      target.parentId
    ) {
      this.draggedItem = null;
      return;
    }

    const items = this.menuItems
      .filter(
        item =>
          item.parentId === target.parentId
      )
      .sort(
        (a, b) => a.sort_ord - b.sort_ord
      );

    const fromIndex =
      items.findIndex(
        item => item.id === this.draggedItem!.id
      );

    const toIndex =
      items.findIndex(
        item => item.id === target.id
      );

    if (
      fromIndex === -1 ||
      toIndex === -1
    ) {
      this.draggedItem = null;
      return;
    }

    const moved = items.splice(
      fromIndex,
      1
    )[0];

    items.splice(
      toIndex,
      0,
      moved
    );

    items.forEach(
      (item, index) => {
        item.sort_ord = index + 1;
      }
    );

    this.draggedItem = null;
  }


  // ==========================================================
  // RESET
  // ==========================================================
  resetFilters(): void {
    this.searchText = '';
    this.filterType = 'all';
    this.filterStatus = 'all';
    this.currentPage = 1;
  }


  // ==========================================================
  // PAGINATION
  // ==========================================================
  onPageSizeChange(): void {
    this.currentPage = 1;
  }


  goToPage(page: number): void {
    if (
      page < 1 ||
      page > this.totalPages
    ) {
      return;
    }

    this.currentPage = page;
  }


  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }


  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }


  // ==========================================================
  // CLOSE FORM
  // ==========================================================
  closeFormModal(): void {
    this.showFormModal = false;
    this.formData = this.getEmptyForm();
  }


  // ==========================================================
  // CLOSE VIEW
  // ==========================================================
  closeViewModal(): void {
    this.showViewModal = false;
    this.selectedMenu = null;
  }


  // ==========================================================
  // CLOSE DELETE
  // ==========================================================
  closeDeleteModal(): void {
    this.showDeleteModal = false;
    this.selectedMenu = null;
  }


  // ==========================================================
  // JSON
  // ==========================================================
  openJsonModal(): void {
    this.showJsonModal = true;
  }


  closeJsonModal(): void {
    this.showJsonModal = false;
  }


  get menuJson(): string {
    return JSON.stringify(
      this.menuItems
        .sort((a, b) => {

          if (a.parentId === b.parentId) {
            return a.sort_ord - b.sort_ord;
          }

          return (a.parentId || '')
            .localeCompare(
              b.parentId || ''
            );
        }),
      null,
      2
    );
  }


  // ==========================================================
  // GENERATE ID
  // ==========================================================
  private generateId(): string {
    const ids = this.menuItems
      .map(item => Number(item.id))
      .filter(id => !isNaN(id));

    if (!ids.length) {
      return '0';
    }

    return String(
      Math.max(...ids) + 1
    );
  }

}
